import {
  Table,
  TableBody,
  TableHead,
  TableHeadColumn,
  TableRow,
  TableRowColumn,
} from '@flowio/react-table';
import moment from 'moment';
import React from 'react';

const displayName = 'LabelErrorsTable';

interface LabelErrorsTableProps {
  labelErrors: io.flow.internal.v0.models.LabelRequestResult[];
}

const LabelErrorsTable: React.FC<LabelErrorsTableProps> = ({
  labelErrors,
}) => (
  <Table striped displayDensity="compact">
    <TableHead>
      <TableRow>
        <TableHeadColumn>Carrier</TableHeadColumn>
        <TableHeadColumn>Error</TableHeadColumn>
        <TableHeadColumn>Origin</TableHeadColumn>
        <TableHeadColumn>Destination</TableHeadColumn>
        <TableHeadColumn>Request Method</TableHeadColumn>
        <TableHeadColumn>Created At</TableHeadColumn>
      </TableRow>
    </TableHead>
    <TableBody>
      {labelErrors.map((labelError) => (
        <TableRow key={labelError.id}>
          <TableRowColumn>{labelError.carrier_id}</TableRowColumn>
          <TableRowColumn>{labelError.error}</TableRowColumn>
          <TableRowColumn>{labelError.origin_country}</TableRowColumn>
          <TableRowColumn>{labelError.destination_country}</TableRowColumn>
          <TableRowColumn>{labelError.label_request_method}</TableRowColumn>
          <TableRowColumn>{moment(labelError.created_at).format('llll')}</TableRowColumn>
        </TableRow>
      ))}
    </TableBody>
  </Table>
);

LabelErrorsTable.displayName = displayName;

export default LabelErrorsTable;
